import React, { useEffect, createElement } from 'react';
import { FadeIn } from './components/FadeIn';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DiaryEntry } from './components/DiaryEntry';
import { ProductExplanation } from './components/ProductExplanation';
import { ExpertQuote } from './components/ExpertQuote';
import { Testimonials } from './components/Testimonials';
import { TrustBar } from './components/TrustBar';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
    const gclid = new URLSearchParams(window.location.search).get('gclid');
    if (gclid) {
      document.querySelectorAll('a[href*="hunderunde.shop"]').forEach(link => {
        const el = link as HTMLAnchorElement;
        const sep = el.href.includes('?') ? '&' : '?';
        el.href = el.href + sep + 'gclid=' + gclid;
      });
    }
  }, []);
  return <div className="min-h-screen flex flex-col font-serif selection:bg-forest/20 selection:text-forest" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow w-full max-w-2xl mx-auto pb-12" data-id="element-2">
        <FadeIn data-id="element-3">
          <HeroSection data-id="element-4" />
        </FadeIn>

        <div className="px-4" data-id="element-5">
          <FadeIn delay={0.1} data-id="element-6">
            <DiaryEntry date="Vor 5 Monaten" title="Das Problem" content={`Felix frisst seinen Napf immer leer. Trotzdem bleibt er dünn. Das Fell ist stumpf. Er wirkt schlapp. Ich kaufe teureres Futter. Wenig Verbesserung.\nDer Tierarzt sagt: "Sein Darm verwertet die Nährstoffe nicht optimal." Ich verstehe nicht wie das sein kann.`} data-id="element-7" />
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-8">
            <DiaryEntry date="Vor 4 Monaten" title="Die Erkenntnis" content={`Ich lese über Verdauungsenzyme, über Ballaststoffe, über Darmgesundheit. Ich verstehe: das Problem liegt nicht im Futter sondern im Darm.\nEin gesunder Darm verwertet Nährstoffe viel effizienter. Ich suche nach natürlicher Unterstützung.`} data-id="element-9" />
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-10">
            <DiaryEntry date="Vor 10 Wochen" title="Der Versuch" content={`Ein Futtertopping mit Ballaststoffen, Präbiotika und verdauungsfördernden Pflanzen. Ich schleiche es langsam ein. Felix frisst es problemlos.\nNach 2 Wochen: der Stuhl verändert sich – kompakter, gesünder. Nach 4 Wochen: er nimmt sichtbar zu. Das Fell glänzt. Er ist lebhafter.`} data-id="element-11" />
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-12">
            <DiaryEntry date="Heute" title="Endlich angekommen" content={`Felix hat sein Idealgewicht fast erreicht. Das Fell ist weich und glänzend. Er tobt wieder wie ein junger Hund.\nDabei habe ich das Futter nicht gewechselt – nur das Topping dazugegeben.`} data-id="element-13" />
          </FadeIn>
        </div>

        <FadeIn delay={0.2} data-id="element-14">
          <ProductExplanation data-id="element-15" />
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-16">
          <ExpertQuote data-id="element-17" />
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-18">
          <Testimonials data-id="element-19" />
        </FadeIn>
      </main>

      <FadeIn delay={0.1} data-id="element-20">
        <TrustBar data-id="element-21" />
      </FadeIn>

      <div className="w-full max-w-2xl mx-auto" data-id="element-22">
        <FadeIn delay={0.2} data-id="element-23">
          <CtaSection data-id="element-24" />
        </FadeIn>
      </div>

      <Footer data-id="element-25" />
    </div>;
}